import React from "react";
import "./LogoutModal.css";

const LogoutModal = ({ isOpen, onClose, onConfirm }) => {
  if (!isOpen) return null;

  return (
    <div className="logout-modal-overlay" onClick={onClose}>
      <div className="logout-modal-content" onClick={(e) => e.stopPropagation()}>
        <h3 className="logout-modal-title">Confirm Logout</h3>
        <p className="logout-modal-message">Are you sure you want to logout?</p>
        <div className="logout-modal-actions">
          <button className="logout-btn-cancel" onClick={onClose}>
            No
          </button>
          <button className="logout-btn-confirm" onClick={onConfirm}>
            Yes
          </button>
        </div>
      </div>
    </div>
  );
};

export default LogoutModal;
